'use strict';

/** @type {import('./ref')} */
module.exports = ReferenceError;



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-errors/ref.js
 ** module id = 401
 ** module chunks = 35
 **/